import { type Locale, navLabel } from '@kovix/shell-kit/i18n';
import type { NavGroup, NavItem } from '@/shared/config/navigation';
import { matchesAll, TASK_COMMANDS } from './taskCommands';

export type Command = NavItem & { group: string; text: string };

/**
 * Lọc mục menu theo chuỗi gõ (nhãn vi/en, tag, nhóm, khóa) — thuần, có test; tối đa 12 kết quả như mockup. Đầu vào là nav ĐÃ lọc quyền (filterNav).
 * Usability test 01/10/2026: so khớp BỎ DẤU và theo từng từ (thứ tự tùy ý) — "phieu thu" khớp "Phiếu thu".
 */
export function filterCommands(nav: NavGroup[], q: string, locale: Locale, limit = 12): Command[] {
  const all: Command[] = nav.flatMap((g) =>
    g.items.map((it) => ({ ...it, group: g.group ?? 'Chung', text: navLabel(it.key, it.label, locale) })),
  );
  const hits = q.trim()
    ? all.filter((it) => matchesAll(`${it.text} ${it.label} ${it.tag} ${it.group} ${it.key}`, q))
    : all;
  return hits.slice(0, limit);
}

/**
 * Usability test 01/10/2026 — tác vụ thường dùng (`TASK_COMMANDS`: "Lập phiếu thu", "Nhập kho"…) cho Ctrl K: chỉ khi có chuỗi gõ và mục menu cha
 * nằm trong nav ĐÃ lọc quyền. Khớp nhãn trước, khớp từ khóa sau.
 */
export function filterTaskCommands(nav: NavGroup[], q: string, locale: Locale, limit = 8): Command[] {
  if (!q.trim()) return [];
  const parents = new Map(
    nav.flatMap((g) => g.items.map((it) => [it.path, { it, group: g.group ?? 'Chung' }] as const)),
  );
  const tasks = TASK_COMMANDS.flatMap((t) => {
    const p = parents.get(t.parent);
    if (!p) return [];
    const parentText = navLabel(p.it.key, p.it.label, locale);
    const c: Command = {
      ...p.it,
      key: t.key,
      label: t.label,
      path: t.path,
      tag: parentText,
      group: p.group,
      text: t.label,
    };
    return [{ c, keywords: t.keywords }];
  });
  const byLabel = tasks.filter((t) => matchesAll(t.c.text, q));
  const byWords = tasks.filter((t) => !byLabel.includes(t) && matchesAll(`${t.c.text} ${t.keywords} ${t.c.tag}`, q));
  return [...byLabel, ...byWords].map((t) => t.c).slice(0, limit);
}
